import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idConductor: Yup.string().required(),
  _idDireccion: Yup.string().required(),
  _idPlaca: Yup.string().required(),
  _idSocio: Yup.string().required(),
  codigoMotivo: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  fechaInicio: Yup.string().required(),
  modalidad: Yup.string().required(),
  numeroDocumento: Yup.string().required(),
  serieDocumento: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
})
